var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Miner",
    transform: "translate(2 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 11671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.75 18.334H14.25C14.9404 18.334 15.5 17.5878 15.5 16.6673L15.5 5.00065C15.5 4.08018 14.9404 3.33398 14.25 3.33398L1.75 3.33398C1.05964 3.33398 0.5 4.08018 0.5 5.00065L0.5 16.6673C0.5 17.5878 1.05964 18.334 1.75 18.334Z",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 90",
    cx: 8,
    cy: 10.834,
    r: 5,
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9993 15.8333L9.66602 12.5",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.33333 9.16732L3 5.83398",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.9993 5.83366L9.66602 9.16699",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.33333 12.5007L4.66667 14.1673L3 15.834",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 92",
    cx: 7.99935,
    cy: 10.8333,
    rx: 2.08333,
    ry: 2.08333,
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 91",
    cx: 7.99935,
    cy: 10.8333,
    rx: 2.08333,
    ry: 2.08333,
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.5 1.04199H5.5",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiner);
export default __webpack_public_path__ + "static/media/miner.8bce58e2a1a6047c4f9e3d81ee3d9ebe.svg";
export { ForwardRef as ReactComponent };